"use client";

import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EnrollNow() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const stats = [{
    number: "15",
    label: "PER COHORT"
  }, {
    number: "5",
    label: "Expert Mentors"
  }, {
    number: "03/26",
    label: "EST. 2026"
  }];
  return <section data-section-id="2182" id="enroll-now" className="relative bg-background text-foreground overflow-hidden py-24 md:py-32 lg:py-[140px] px-6 md:px-10 lg:px-16">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.03] mix-blend-multiply" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {}
          <div ref={textRef} data-index={0} className="lg:col-span-7 transition-all duration-[800ms] ease-out" style={{
          opacity: textVisible ? 1 : 0,
          transform: textVisible ? "translateY(0)" : "translateY(24px)"
        }}>
            <p className="font-mono text-xs md:text-sm uppercase tracking-[0.25em] mb-8 text-primary">
              Future Leaders
            </p>

            <h2 className="font-default font-bold leading-[1.05] mb-10 text-4xl md:text-5xl lg:text-6xl xl:text-[72px] text-foreground">
              Excellence is not
              <br />
              accidental. It is
              <br />
              <em className="italic font-serif font-medium text-primary">
                cultivated.
              </em>
            </h2>

            <p className="font-default text-base md:text-lg leading-relaxed max-w-[480px] mb-10 text-muted-foreground">
              Through our specialized curriculum and immersive workshops, we nurture the next generation of creative thinkers. Our cohorts are intentionally small to ensure personalized mentorship and deep technical mastery.
            </p>

            <div className="flex flex-col sm:flex-row gap-6 sm:items-center">
              <Button asChild size="lg" className="font-default text-base px-8 h-12 rounded-md shadow-md hover:shadow-lg transition-all bg-primary text-primary-foreground hover:bg-primary/90">
                <Link to="https://form.jotform.com/africabusinessschool12/course-application-form" target="_blank" rel="noopener noreferrer">Apply for Admission</Link>
              </Button>

              <Link to="/OurProgramsPage" className="inline-flex items-center gap-2 font-default text-base group text-primary">
                <span className="border-b pb-1 transition-colors border-primary/30 group-hover:border-primary">
                  Explore Our Programs
                </span>
                <ArrowUpRight className="size-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative">
            <div ref={imageRef} data-index={1} className="relative transition-all duration-[800ms] ease-out" style={{
            opacity: imageVisible ? 1 : 0,
            transform: imageVisible ? "translateY(0)" : "translateY(24px)"
          }}>
              <div className="relative aspect-[4/5] w-full overflow-hidden rounded-md shadow-xl">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/startup-software-developers-doing-brainstorming-office-scaled.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/startup-software-developers-doing-brainstorming-office-scaled.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696678/img/startup-software-developers-doing-brainstorming-office-scaled.png-wvc-sizes" alt="A mentor guiding a student through a complex creative project in a modern studio" loading="lazy" decoding="async" className="w-full h-full object-cover" />
                <div aria-hidden="true" className="absolute inset-0 rounded-md pointer-events-none border border-primary/10" />
              </div>

              {}
              <Card ref={cardRef} className="absolute -bottom-10 -left-4 sm:-left-10 w-[78%] sm:w-[280px] p-7 rounded-md shadow-2xl transition-all duration-[800ms] ease-out bg-card text-card-foreground border-none" style={{
              transitionDelay: "400ms",
              opacity: cardVisible ? 1 : 0,
              transform: cardVisible ? "translateY(0)" : "translateY(24px)"
            }}>
                <div className="flex flex-col gap-5">
                  {stats.map((stat, i) => <div key={i} data-index={i} className={i < stats.length - 1 ? "pb-5 border-b border-muted" : ""}>
                      <div className="font-default font-bold text-4xl leading-none mb-2 text-primary">
                        {stat.number}
                      </div>
                      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                        {stat.label}
                      </div>
                    </div>)}
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>;
}